import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-action';
import '../../common/bn-placeholder';
import '../../common/bn-load-more-button';
import './work-order-list-item';

class WorkOrderList extends LitEntity {
  constructor() {
    super();
    this.workOrders = [];
  }

  static get properties() {
    return {
      fullPath: { type: Boolean, attribute: 'full-path' },
      hideAddress: { type: Boolean, attribute: 'hide-address' },
      hideState: { type: Boolean, attribute: 'hide-state' },
      historical: { type: Boolean },
      workOrders: { type: Array, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .no-data {
        text-align: center;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`<p class="no-data"><bn-loading></bn-loading></p>`;
    }
    if (!this.workOrders.length) {
      return html`<slot name="empty"><p class="no-data">No Work Orders to display.</p></slot>`;
    }
    return html`
      <div class="work-orders">
        ${this.workOrders.map((workOrder) => html`
          <work-order-list-item
            .href="${workOrder.getLink('self').href}"
            @response="${this._onResponse}"
            ?hide-state="${this.hideState}"
            ?full-path="${this.fullPath}"
            ?hide-address="${this.hideAddress}"
            ?historical="${this.historical}"
          ></work-order-list-item>
        `)}
        ${renderIf(this.loading, () => html`<bn-loading></bn-loading>`)}
      </div>
      <bn-load-more-button .href="${this.href}" @moreloaded="${this._onMoreLoaded}"></bn-load-more-button>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.workOrders = (this.entity && this.entity.getSubEntitiesByClass('work-order')) || [];
  }

  _onResponse() {
    entityStore.invalidateHref(this.href);
  }

  async _onMoreLoaded(e) {
    const { entity } = e.detail;
    this.workOrders = [...this.workOrders, ...entity.getSubEntitiesByClass('work-order')];
  }
}

customElements.define('work-order-list', WorkOrderList);
